import { faTags } from '@fortawesome/pro-regular-svg-icons';

import RcsSectionBlock from './RcsSectionBlock';
import InfoItem from './InfoItem';
import InfoItemLayout from './InfoItemLayout';
import { RcsCampaign } from '../../types';
import {
  getRussell3000,
  getGovernmentEntity,
  getPoliticalCommitteeLocale,
  getTaxExemptStatus,
} from '@/applications/CspPortal/Brands/utils';

const BrandDetailsSection = ({ campaign }: { campaign: RcsCampaign }) => {
  const { brand } = campaign;

  return (
    <RcsSectionBlock
      icon={faTags}
      title="Brand Details"
      showDivider={true}
      editable={false}
    >
      <InfoItemLayout.Vertical>
        <InfoItemLayout.Horizontal>
          <InfoItem title="Brand Legal Name">{brand?.companyName}</InfoItem>
          <InfoItem title="Brand Support Email">{brand?.email}</InfoItem>
        </InfoItemLayout.Horizontal>

        <InfoItemLayout.Horizontal>
          <InfoItem title="Brand DBA Name">{brand?.displayName}</InfoItem>
          <InfoItem title="Russell3000">{getRussell3000(brand)}</InfoItem>
        </InfoItemLayout.Horizontal>

        <InfoItemLayout.Horizontal>
          <InfoItem title="Entity Type">{brand?.entityType}</InfoItem>
          <InfoItem title="Tax Exempt Status">
            {getTaxExemptStatus(brand)}
          </InfoItem>
        </InfoItemLayout.Horizontal>

        <InfoItemLayout.Horizontal>
          <InfoItem title="External Vetting Score">
            {Number.isInteger(brand?.evpVettingScore)
              ? String(brand.evpVettingScore)
              : null}
          </InfoItem>
          <InfoItem title="Government Entity">
            {getGovernmentEntity(brand)}
          </InfoItem>
        </InfoItemLayout.Horizontal>

        <InfoItemLayout.Horizontal>
          <InfoItem title="Website/Online Presence">{brand?.website}</InfoItem>
          <InfoItem title="Political Committee Locale">
            {getPoliticalCommitteeLocale(brand)}
          </InfoItem>
        </InfoItemLayout.Horizontal>

        <InfoItemLayout.Horizontal>
          <InfoItem title="Support Phone Number">{brand?.phone}</InfoItem>
        </InfoItemLayout.Horizontal>
      </InfoItemLayout.Vertical>
    </RcsSectionBlock>
  );
};

export default BrandDetailsSection;
